import type { TransactionId } from "@budgeter/shared";

/**
 * Transactions added on this device since the app opened. Lost on reload, so the per-row
 * "waiting to sync" marker is a hint; the sync badge is the source of truth.
 */
const addedHere = new Set<string>();

export function markAddedHere(id: TransactionId): void {
  addedHere.add(id);
}

export function wasAddedHere(id: TransactionId): boolean {
  return addedHere.has(id);
}
